import { Command } from './Command';

/**
 * DeleteObjectCommand - Deletes an object from the canvas
 *
 * Stores the object's z-index (layer position) to restore it correctly on undo.
 *
 * @example
 * const command = new DeleteObjectCommand(canvas, selectedObject);
 * commandStack.execute(command);
 */
export class DeleteObjectCommand extends Command {
  /**
   * @param {Canvas} canvas - Fabric.js canvas instance
   * @param {Object} object - Fabric.js object to delete
   */
  constructor(canvas, object) {
    super();
    this.canvas = canvas;
    this.object = object;
    // Store z-index for proper restoration
    this.objectIndex = canvas.getObjects().indexOf(object);
  }

  execute() {
    this.canvas.remove(this.object);
    this.canvas.discardActiveObject();
    this.canvas.renderAll();
  }

  undo() {
    // Restore object at original z-index (layer position)
    // Note: We need to add the object first, then move it to the correct position
    this.canvas.add(this.object);

    // Move to original z-index if it's not already there
    const currentIndex = this.canvas.getObjects().indexOf(this.object);
    if (currentIndex !== this.objectIndex) {
      this.canvas.moveTo(this.object, this.objectIndex);
    }

    this.canvas.setActiveObject(this.object);
    this.canvas.renderAll();
  }

  getDescription() {
    const type = this.object.data?.type || this.object.type;
    return `Delete ${type}`;
  }
}
